export const SET_AE_INFO = "SET_AE_INFO";
export const RESET_AE_INFO = "RESET_AE_INFO";

const initialState = null;

export default function procurationAeReducers(
  state = initialState,
  action: any,
) {
  switch (action.type) {
    case SET_AE_INFO:
      return action.payload;
    case RESET_AE_INFO:
      return null;
    default:
      return state;
  }
}
